<div class="warning-card">
  <das-info-banner [showDas2Banner]="true" [diaryBanner]="true"></das-info-banner>
  <p>{{ warningText }}</p>
</div>
